import React, { useState } from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import DocViewer from '../../components/DocViewer';
import UserProfile from '../../components/user/UserProfile';
import { moneyFormat, truncateString } from '../../utils/methods';

export default function CaseDetail() {

  const [showProfile, setShowProfile] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [visiblePane, setVisiblePane] = useState(1);
  const [documentToOpen, setDocumnetToOpen] = useState(null);

  const navigate = useNavigate();

  // const user = useAuthStore((state) => state.user);
  const caseData = useLoaderData();

  const showPersonProfile = (user) => {
    setShowProfile(true);
    setSelectedUser(user);
  }

  const closeProfileModal = () => {
    setSelectedUser(null);
    setShowProfile(false);
  }

  const openDocument = (fileData) => {
    setDocumnetToOpen(fileData)
  }

  return (
    <div className="relative">
      <DocViewer fileData={documentToOpen} onClose={() => {
        setDocumnetToOpen(null);
      }} />

      <div className="wrapper-2 animate__animated animate__fadeIn">
        {showProfile && <UserProfile user={selectedUser} onClose={closeProfileModal} />}
        <div className="gradient-bg relative rounded-b-lg py-12 mb-10 px-8 flex lg:items-center lg:flex-row flex-col justify-start lg:justify-between items-start gap-4">
          <div>
            <h1 className="font-fira xl:text-2xl text-xl">Case Resolution Details</h1>
            {/* <p className="text-xs lg:text-sm font-taviraj">Resolve your issues easily and risk free</p> */}
          </div>
          <Link to="/account/dashboard" className=" border-2 border-blue-900 px-4 py-2 gap-1 flex items-start hover:text-blue-900 rounded-lg text-gray-800 font-semibold text-xs left-8">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clipRule="evenodd" />
              </svg>
            </span>

            <span>
              Dashboard
            </span>
          </Link>
        </div>


        <div className="px-4 md:px-0">
        {<div className="mt-4 mb-8">
          <button onClick={(e) => {
              e.preventDefault();
              navigate(`/neutral/schedule-meeting/${caseData._id}`)
          }} className='bg-blue-800 text-white py-3 text-xs font-semibold font-fira rounded-lg hover:bg-blue-900 lg:w-1/5 w-full text-center'>Schedule a Meeting</button>
        </div>}
          <div className="mt-4 bg-gray-100 pb-6  rounded-lg border-2 border-gray-300">
            {/* Pane Header */}
            <div className="py-2 px-4 lg:px-8 border-b border-gray-500 overflow-x-scroll">
              <ul className="flex gap-8 items-center font-semibold font-fira">
                <li key={1}><a href="#!" onClick={(e) => { e.preventDefault(); setVisiblePane(1) }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 1 ? 'bg-blue-900 text-white' : 'text-gray-800'}  whitespace-nowrap`}>PARTIES</a></li>
                <li key={2}><a href="#!" onClick={(e) => { e.preventDefault(); setVisiblePane(2) }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 2 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>FACTS OF THE CASE</a></li>
                <li key={3}><a href="#!" onClick={(e) => { e.preventDefault(); setVisiblePane(3) }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 3 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>DOCUMENTS/EVIDENCE</a></li>
                <li key={4}><a href="#!" onClick={(e) => { e.preventDefault(); setVisiblePane(4) }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 4 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>PROCEEDINGS</a></li>
                <li key={5}><a href="#!" onClick={(e) => { e.preventDefault(); setVisiblePane(5) }} className={`px-3 transition-color ease-in-out delay-150 py-1 rounded-lg text-xs ${visiblePane === 5 ? 'bg-blue-900 text-white' : 'text-gray-800'} whitespace-nowrap`}>RESOLUTION</a></li>
              </ul>
            </div>

            {/* Pane Body */}
            <div className="mt-5">
              {visiblePane === 1 && <div>
                <h4 className="text-sm mx-4 lg:mx-8  font-semibold font-fira text-gray-800">
                  Involved Parties
                </h4>

                <div className="mt-3">
                  <ul>

                    {Array.from([...caseData.claimants, ...caseData.defendants]).map((ip) => {
                      return (<li onClick={() => [
                        showPersonProfile(ip)
                      ]} className="mb-4 lg:px-8 px-4 py-3 hover:bg-white border-b-2 border-gray-300 cursor-pointer w-full">
                        <div className="flex gap-2 items-center">
                          <img src="https://avatars.dicebear.com/api/initials/Oduma%20Daniel.svg" className="h-10 w-10 rounded-full" alt="Nuetral avatar" />
                          <div className="w-full break-words">
                            <div className="flex justify-between">
                              <h4 className="text-sm font-semibold font-fira">{ip.name}</h4>
                              <h4 className="text-xs font-taviraj">{ip.profile.state} {ip.profile.country}</h4>
                            </div>
                            <div className="flex justify-between break-words">
                              <span className="font-semibold text-xs hover:text-blue-800  text-gray-600">{ip.email}</span>
                              <span className="font-semibold text-xs hover:text-blue-800  text-gray-600">{ip.profile.phone}</span>
                            </div>
                          </div>
                        </div>
                      </li>)
                    })}
                  </ul>
                </div>

              </div>}
              {visiblePane === 2 && <div className="lg:px-8 px-6">
                <h4 className="text-sm mb-4 font-semibold font-fira text-gray-800">
                  Facts of Case
                </h4>

                <div className="">
                  <h4 className="mb-1 text-xs font-semibold text-gray-600">Description -- Claimant</h4>
                  <p className="text-xs text-gray-700">
                    {caseData.facts.claimant.description}
                  </p>
                </div>

                {caseData.facts.defendant.description && <div className="mt-4">
                  <h4 className="mb-1 text-xs font-semibold text-gray-600">Description --- Defendant</h4>
                  <p className="text-xs text-gray-700">
                    {caseData.facts.defendant.description}
                  </p>
                </div>}

                <div className="mt-4">
                  <h4 className="mb-1 text-xs font-semibold text-gray-600">Industry</h4>
                  <p className="text-xs text-gray-700">
                    {caseData.facts.claimant.industry}
                  </p>
                </div>

                <div className="mt-4">
                  <h4 className="mb-1 text-xs font-semibold text-gray-600">Reliefs</h4>
                  <p className="text-xs text-gray-700">
                    {caseData.facts.claimant.reliefs}
                  </p>
                </div>

                <div className="mt-4">
                  <h4 className="mb-1 text-xs font-semibold text-gray-600">Monetary Claim</h4>
                  <p className="text-xs text-gray-700">
                    {moneyFormat(caseData.monetaryClaim)}
                  </p>
                </div>

                {caseData.monetaryCounterClaim && <div className="mt-4">
                  <h4 className="mb-1 text-xs font-semibold text-gray-600">Counter Monetary Claim</h4>
                  <p className="text-xs text-gray-700">
                    {moneyFormat(caseData.monetaryCounterClaim)}
                  </p>
                </div>}

                <div className="mt-4">
                  <h4 className="mb-1 text-xs font-semibold text-gray-600">BATNA</h4>
                  <p className="text-xs text-gray-700">
                    {moneyFormat(caseData.banta)}
                  </p>
                </div>
              </div>}
              {visiblePane === 3 && <div className="lg:px-8 px-6">
                <h4 className="text-sm mb-4 font-semibold font-fira text-gray-800">
                  Documents/Envidences
                </h4>

              {caseData.documents !== null && <div className="mt-4">
                <div className="justify-between cursor-pointer text-blue-800 bg-white rounded-lg py-3 px-4 flex items-center text-xs font-semibold gap-6">
                  {Array.from(caseData.documents).map((doc) => {
                    return (<div onClick={() => {
                      openDocument(doc.fileData);
                    }} className="flex gap-3 items-center">
                      <span>
                        {doc.fileData.type === 'image' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path fillRule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clipRule="evenodd" />
                        </svg>}

                        {doc.fileData.type === 'video' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path d="M4.5 4.5a3 3 0 00-3 3v9a3 3 0 003 3h8.25a3 3 0 003-3v-9a3 3 0 00-3-3H4.5zM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06z" />
                        </svg>}

                        {doc.fileData.type === 'application' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z" />
                          <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                        </svg>}

                        {doc.fileData.type === 'text' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path fillRule="evenodd" d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625zM7.5 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 017.5 15zm.75 2.25a.75.75 0 000 1.5H12a.75.75 0 000-1.5H8.25z" clipRule="evenodd" />
                          <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                        </svg>}
                      </span>
                      <span title={doc.fileData.public_id}>
                        {truncateString(doc.fileData.public_id)}
                      </span>
                    </div>)
                  })}
                </div>
                {caseData.documents === null && <div className="text-sm font-semibold">
                  <h4>No Documents was submitted</h4>
                </div>}
              </div>}
              </div>}
              {visiblePane === 4 && <div className="lg:px-8 px-6">
                <h4 className="text-sm mb-4 font-semibold font-fira text-gray-800">
                  Proceedings
                </h4>

                <div className="mt-4 min-w-screen w-full overflow-x-scroll">
                  <table className="min-w-max w-full table-auto">
                    <thead className="text-xs font-fira bg-gray-100 whitespace-nowrap">
                      <tr>
                        <th className="py-3 px-3 text-left">#</th>
                        <th className="py-3 px-3 text-left">DATE</th>
                        <th className="py-3 px-3 text-left">TIME</th>
                        <th className="py-3 px-3 text-left">TYPE</th>
                        <th className="py-3 px-3 text-left">LINK</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.from(caseData.proceedings).map((cp) => {
                        return (
                          <tr className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{caseData.indexOf(cp)}</td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{cp.date} </td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{cp.time}</td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>{cp.type}</td>
                            <td className='py-3 px-3 text-left whitespace-nowrap'>
                              <a href={cp.link} target="_blank" className="hover:text-blue-900" rel="noreferrer">Open Link</a>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>

              </div>}
              {visiblePane === 5 && <div className="lg:px-8 px-6">
                <h4 className="text-sm mb-4 font-semibold font-fira text-gray-800">
                  Settlement
                </h4>

                {caseData.verdict !== null && <div>
                  <div className="">
                    <h4 className="mb-1 text-xs font-semibold text-gray-600">Mediator Comment</h4>
                    <p className="text-xs text-gray-700">
                      {caseData.verdict.comment}
                    </p>
                  </div>

                  <div className="mt-4">
                    <h4 className="mb-1 text-xs font-semibold text-gray-600">In Favour Of</h4>
                    <p className="text-xs text-gray-700">
                      {caseData.verdict.inFavour}
                    </p>
                  </div>

                  <div onClick={() => {
                    openDocument(caseData.verdict.report);
                  }} className="flex gap-3 items-center">
                    <span>
                      {caseData.verdict.report.type === 'application' && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                        <path d="M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0016.5 9h-1.875a1.875 1.875 0 01-1.875-1.875V5.25A3.75 3.75 0 009 1.5H5.625z" />
                        <path d="M12.971 1.816A5.23 5.23 0 0114.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 013.434 1.279 9.768 9.768 0 00-6.963-6.963z" />
                      </svg>}
                    </span>
                    <span title={caseData.verdict.report.public_id}>
                      {truncateString(caseData.verdict.report.public_id)}
                    </span>
                  </div>
                </div>}

                {caseData.verdict === null && <div className="text-sm font-semibold">
                  <h4>No Settlement Reached</h4>
                </div>}


              </div>}

            </div>
          </div>
        </div>
      </div>      
    </div>
  )
}
